export default "__VITE_ASSET__c4IVeNEl__"